export default __webpack_public_path__ + "static/media/Like_Unselected.31bf9f56.svg";